import { createContext, type FC, useContext, type ReactNode } from 'react';

export const ServerVarsContext = createContext<ServerVarsContextProviderProps>({});

export type ServerVarsContextProviderProps = {
    isDesktop?: boolean;
    isMobile?: boolean;
    isTablet?: boolean;
    originalUrl?: string;
    areDisplayAdsEnabled?: boolean;
    tradeBenefitsVideoPlaybackId?: string;
    muxMonitoringFF?: boolean;
};

export const ServerVarsContextProvider: FC<
    ServerVarsContextProviderProps & { children: ReactNode }
> = ({
    children,
    isDesktop,
    isMobile,
    isTablet,
    originalUrl,
    areDisplayAdsEnabled,
    tradeBenefitsVideoPlaybackId,
    muxMonitoringFF,
}) => (
    <ServerVarsContext
        value={{
            isDesktop,
            isMobile,
            isTablet,
            originalUrl,
            areDisplayAdsEnabled,
            tradeBenefitsVideoPlaybackId,
            muxMonitoringFF,
        }}
    >
        {children}
    </ServerVarsContext>
);

export function useServerVars(): ServerVarsContextProviderProps {
    return useContext(ServerVarsContext);
}
